module.exports = ($scope, $state, sources, $stateParams, country) ->
  $scope.loadPage = (page) ->
    $stateParams.page = page
    $stateParams.start = (page - 1) * 25
    $state.go('country-sources', $stateParams)
    $state.reload()

  add_colour = (sources) ->
    for source in sources
      if source.type == "googlecustomsearch" or source.type == "scarab"
        source.colour = "green"
      else if source.type == "kraken"
        if source.full_status == "unsearched_healthy" or source.full_status == "partially_healthy"
          source.colour = "yellow"
        else
          source.colour = "green"
      else
        if source.full_status == "partially_healthy"
          source.colour = "yellow"
        else
          source.colour = "green"

  add = (count) ->
    $scope.totalSources += count


  $scope.sourcesInSearch = sources.data.iTotalRecords
  $scope.currentPage = $stateParams.page
  $scope.country = country.data.country
  $scope.categories = country.data.country.num_sources
  $scope.isoCode = $stateParams.isoCode
  $scope.currentCategory = $stateParams.category

  $scope.sources = sources.data.aaData
  add_colour $scope.sources

  $scope.totalSources = 0
  add category.count for k, category of $scope.categories


